<div [ngClass]="{'custom-padding': customPadding}" class="body bg-white px-3 pb-5 pt-3 py-lg-4  px-lg-5 d-flex flex-column h-55">
    <ng-content></ng-content>
</div>
